import mapValues from 'lodash/mapValues'
import merge from 'lodash/merge'
import Vue from 'vue'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import ContextHeader from './ContextHeader'
import KwicHeader from './KwicHeader'
import FullFrequencyResult from './FullFrequencyResult'
import ContextResult from './ContextResult'

const components = {
  ...Ncs.defaultComponents,
  NcsContextDocumentHeader: ContextHeader,
  NcsKwicResultHeader: KwicHeader,
  NcsFullFrequencyResult: FullFrequencyResult,
  NcsContextResult: ContextResult
}

function csvElementFields(document, text, elements, matches) {
  return mapValues({
    [this.$i18n.t('result.context.header.document.subcorpus')]: document.subcorpus,
    [this.$i18n.t('result.context.header.document.language')]: document.language,
    [this.$i18n.t('result.context.header.document.text_genre')]: document.text_genre,
    [this.$i18n.t('result.context.header.document.text_subgenre')]: document.text_subgenre,
    [this.$i18n.t('result.context.header.document.specialization')]: document.specialization,
    [this.$i18n.t('result.context.header.document.title')]: document.title,
  }, v => v ? v : '')
}

Vue.use(Ncs, {config: merge(gon.config, config), components, csvElementFields})

export {Vue, Ncs}